// Địa giới hành chính Việt Nam (2 cấp: Tỉnh/Thành phố -> Xã/Phường, theo cơ
// cấu sau sáp nhập 2025 — cấp Huyện đã bị bỏ). Dữ liệu lấy từ API công khai
// provinces.open-api.vn, cache lại trong bộ nhớ để khỏi gọi lại nhiều lần.

const BASE_URL = "https://provinces.open-api.vn/api/v2";

let tinhCache = null;
const xaCacheTheoTinh = {};

export const diaChiApi = {
  async danhSachTinh() {
    if (tinhCache) return tinhCache;
    const res = await fetch(`${BASE_URL}/p/`);
    if (!res.ok) throw new Error("Không tải được danh sách tỉnh/thành phố");
    const data = await res.json();
    tinhCache = data.map((t) => ({ code: String(t.code), name: t.name }));
    return tinhCache;
  },

  async danhSachXa(maTinh) {
    if (!maTinh) return [];
    if (xaCacheTheoTinh[maTinh]) return xaCacheTheoTinh[maTinh];
    const res = await fetch(`${BASE_URL}/p/${maTinh}?depth=2`);
    if (!res.ok) throw new Error("Không tải được danh sách xã/phường");
    const data = await res.json();
    const ds = (data.wards ?? []).map((x) => ({ code: String(x.code), name: x.name }));
    xaCacheTheoTinh[maTinh] = ds;
    return ds;
  },
};
